"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionProgress = sessionProgress;

var _bn = _interopRequireDefault(require("bn.js"));

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _chain = require("../chain");

var _drr = require("../util/drr");

// Copyright 2017-2019 @polkadot/api-derive authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
function sessionProgress(api) {
  return () => (0, _rxjs.combineLatest)([(0, _chain.bestNumber)(api)(), api.query.session.sessionLength(), api.query.session.lastLengthChange()]).pipe((0, _operators.map)((_ref) => {
    let [bestNumber, sessionLength, lastLengthChange] = _ref;
    return (bestNumber || new _bn.default(0)).sub(lastLengthChange.unwrapOr(new _bn.default(0))).add(sessionLength || new _bn.default(1)).mod(sessionLength || new _bn.default(1));
  }), (0, _drr.drr)());
}